import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';
import { Discipline } from 'src/app/models/discipline.model';
import { Member } from 'src/app/models/member.model';
import { Vestiging } from 'src/app/models/vestiging.model';
import { DisciplineService } from 'src/app/services/discipline.service';
import { LocationService } from 'src/app/services/location.service';
import { MediaService } from 'src/app/services/media.service';
import { PageService } from 'src/app/services/page.service';
import { TeamService } from 'src/app/services/team.service';

const TEAM_HEADER:string = "assets/images/hero/bg-team.jpg"
declare var choiceSelect:any;

@Component({
  selector: 'team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.sass']
})
export class TeamComponent implements OnInit {

  members: Member[] = [];
  vestigingen: Vestiging[] = [];
  disciplines: Discipline[] = [];
  filterargs: any = {};

  locatieSelect:any;
  discSelect:any;

  selectedDiscipline:any = null;

  constructor(
    private teamService:TeamService,
    private mediaService:MediaService,
    private locationService:LocationService,
    private disciplineService:DisciplineService,
    private activatedRoute: ActivatedRoute,
    private pageService:PageService
  ) { }

  ngOnInit(): void {
    this.pageService.setCurrentHeader(TEAM_HEADER);

    this.locationService.getVestigingen().subscribe(data => {
      data.data.forEach((vestiging: any) => {
          this.vestigingen.push(vestiging);
      });

      this.disciplineService.getDisciplines().subscribe(data => {
        data.data.forEach((discipline: any) => {
            this.disciplines.push(discipline);
        });

        this.initFilters();
      });
    });

    this.teamService.getTeam().subscribe(data => {
      data.data.forEach((element: any) => {
        let member = this.teamService.populateTeamlid(element);
        this.members.push(member);
      });
    });
  }

  initFilters(): void {
    this.locatieSelect = choiceSelect.initChoices('choices-location');
    this.discSelect = choiceSelect.initChoices('choices-disc');

    // init choices object
    let locChoices = [];
    for(let v of this.vestigingen) {
      locChoices.push({"value": v.naam, "label": v.naam, "selected": false});
    }
    //locChoices[0].selected = true;

    let discChoices = [];
    for(let d of this.disciplines) {
      discChoices.push({"value": d.naam, "label": d.naam, "selected": false});
    }

    // insert choices
    this.locatieSelect.setChoices(
      locChoices,
      'value',
      'label',
      false,
    );

    this.discSelect.setChoices(
      discChoices,
      'value',
      'label',
      false,
    );

    // add callback event
    this.locatieSelect.passedElement.element.addEventListener(
      'choice',
      function(event:any) {
        let v = event.detail.choice.value;
      },
      false,
    );

    // add callback event
    let self = this;
    this.discSelect.passedElement.element.addEventListener(
      'choice',
      function(event:any) {
        let d = event.detail.choice.value;
        self.selectedDiscipline = d == "alle" ? null : self.getDiscipline(d);
      },
      false,
    );

    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;

    if(!params) return;
    if(params['praktijk']) {
      this.filterargs.praktijk = params['praktijk'];
      this.locatieSelect.setChoiceByValue(params["praktijk"]);
    }
    if(params['discipline']) {
      this.filterargs.discipline = params['discipline'];
      this.discSelect.setChoiceByValue(params["discipline"]);
    }

  }

  resetFilters():void {
    this.filterargs = {};
    this.locatieSelect.setChoiceByValue("alle");
    this.discSelect.setChoiceByValue("alle");
    this.selectedDiscipline = null;
  }

  getDiscipline(d:string) {
    return this.disciplines.filter(disc => disc.naam.toLowerCase() == d.toLowerCase())[0];
  }

}
